module.exports = __webpack_public_path__ + "img/nandu10.8a08876c.png";